import React from "react";
import PropTypes from "prop-types";

const Spinner = props => {
  const { clases = "m-3" } = props;
  return (
    <div className="text-center">
      <output className={`spinner-border text-primary ${clases}`} aria-label="loading">
        <span className="visually-hidden">Loading...</span>
      </output>
    </div>
  );
};

Spinner.propTypes = {
  clases: PropTypes.string,
};

export default Spinner;

export const SpinnerModal = ({ txt }) => {
  return (
    <div className="border rounded-3 py-1 px-2 mb-5 mx-3 d-flex flex-row justify-content-between align-items-center">
      <div>
        <span className="fw-bold">Guardando: </span>
        <label className="ms-1">{txt}...</label>
      </div>
      <output style={{ height: "17px", width: "17px", paddingTop: "4px" }} className="spinner-border text-primary" aria-label="loading">
        <span className="visually-hidden">Loading...</span>
      </output>
    </div>
  );
};

SpinnerModal.propTypes = {
  txt: PropTypes.string.isRequired,
};
